import { DeaspTable } from "pages/patient/PatientDocumentsPage/components/DeaspTable/DeaspTable";

import { AddFormForm } from "components/AddFormForm/AddFormForm.jsx";
import { HseDetailsNotice } from "components/ui/HseDetailsNotice/HseDetailsNotice";
import { useCurrentPatientId } from "features/patients/hooks/useCurrentPatientId";
import { usePatientData } from "features/patients/hooks/usePatientData";
import { usePracticeSettings } from "features/practice/hooks/usePracticeSettings";

import s from "./tabs.module.css";

export const FormTab = ({ consultation, isReadOnly = false }) => {
  const patientId = useCurrentPatientId();
  const { data: patient } = usePatientData();
  const { data: practiceSettings } = usePracticeSettings();

  if (isReadOnly) {
    return (
      <div className={s.sectionWrapper}>
        <DeaspTable patientId={patientId} bare />
      </div>
    );
  }

  return (
    <>
      {/* Shown above the tab as well as inside the e-cert form: a GP should see that
          nothing can be sent for this patient before choosing a form type (KIN-1733). */}
      <HseDetailsNotice
        patient={patient}
        patientId={patientId}
        submissionName="to the DEASP"
      />
      <AddFormForm
        patient={patient}
        consultation={consultation}
        healthlinkEnabled={practiceSettings?.healthLink !== false}
      />
      <div className={s.sectionWrapper}>
        <DeaspTable patientId={patientId} bare />
      </div>
    </>
  );
};
